import { CommonModule } from '@angular/common';
import {
  ErrorHandler,
  inject,
  Injector,
  NgModule,
  provideAppInitializer,
} from '@angular/core';
import { GlobalErrorHandler } from '@core/error/global-error-handler';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerLocalesEnum } from '@shared/enums/mat-datepicker-locales.enum';
import { AppStorage } from '@shared/storage/app-storage';
import { AppLangEnum } from '@shared/enums/app-lang.enum';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorIntlService } from '@shared/services/paginator-intl.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { LOCATION_URL } from '@core/consts/location-url';
import { environment } from '@root/environments/environment';
import { AuthStoreService } from './auth/auth-store.service';
import { firstValueFrom } from 'rxjs';
import { ErrorAggregatorService } from '@root/app/error-aggregation/error-aggregator.service';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { provideNgxMatNativeDate } from '@ngxmc/datetime-picker';

export function initializeApp(injector: Injector): () => Promise<void> {
  return async () => {
    const authStoreService = injector.get(AuthStoreService);
    const errorAggregatorService = injector.get(ErrorAggregatorService);
    errorAggregatorService.addIndexChunksHashes();
    firstValueFrom(
      authStoreService.initAuth()
    ) as Promise<unknown> as Promise<void>;
  };
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatSnackBarModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: MAT_DATE_LOCALE,
      useValue:
        AppStorage.getLanguage() === AppLangEnum.ar
          ? MatDatepickerLocalesEnum.Ar
          : MatDatepickerLocalesEnum.En,
    },
    {
      provide: MatPaginatorIntl,
      useClass: PaginatorIntlService,
    },
    {
      provide: LOCATION_URL,
      useValue: `${environment.apiUrl}/v2/LocationsManagement`,
    },
    provideAppInitializer(() => {
      const initializerFn = initializeApp(inject(Injector));
      return initializerFn();
    }),
    provideNgxMatNativeDate(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic',
      } satisfies MatFormFieldDefaultOptions,
    },
  ],
})
export class CoreModule {}
